import {from, of} from 'rxjs';
import {mergeMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import * as Queries from 'web-app/react/settings/queries';
import {type GetSignInBehavioursQuery} from 'web-app/react/settings/__generated__/queries.api-types';

import * as Actions from './actions';

const getQRBehavior = () => {
    return from(
        getApolloClient().query<GetSignInBehavioursQuery>({
            query: Queries.GetSignInBehaviours,
            fetchPolicy: 'network-only',
        }),
    ).pipe(
        mergeMap(({data}) => {
            return of({
                isEnabled: data?.qrSignin.siteSettings.siteSettings.some(el => el.isEnabled),
                canManage: data?.qrSignin.siteSettings.siteSettings.some(el => el.canManage),
            });
        }),
        catchError(() => {
            return of(null);
        }),
    );
};

const qrSigninBehavior = action$ =>
    action$.ofType(Actions.getQRSigninBehavior.type).mergeMap(() => {
        return getQRBehavior().map(result => {
            return Actions.getQRSigninBehaviorSuccess.action(result);
        });
    });

export default combineEpics(qrSigninBehavior);
